import { createApiService } from "@/core/api/apiService";
import type { SquareCompleteDto, SquareConnectDto, SquareConnectionDto } from "../types/squareTypes";

export function createSquareApiService() {
  const api = createApiService("businesses");
  return {
    getByBusinessId: (businessId: string, signal?: AbortSignal) =>
      api.get<SquareConnectionDto>(`/${businessId}/square`, { signal }),
    connect: (businessId: string, dto: SquareConnectDto, signal?: AbortSignal) =>
      api.post<{ authorization_url: string }>(`/${businessId}/square/connect`, dto, { signal }),
    complete: (businessId: string, dto: SquareCompleteDto) =>
      api.post<SquareConnectionDto>(`/${businessId}/square/complete`, dto),
    disconnect: (businessId: string) =>
      api.delete<{ message: string }>(`/${businessId}/square`),
  };
}

export const squareApiService = createSquareApiService();
